import FusePageSimple from '@fuse/core/FusePageSimple';
import withReducer from 'app/store/withReducer';
import { Outlet } from 'react-router-dom';
import React, { useEffect, useRef, useState, createContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDeepCompareEffect } from '@fuse/hooks';
import { styled } from '@mui/material/styles';
import history from '@history';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import ChannelRightSidebarContent from './ChannelRightSidebarContent';
import ChannelLeftSidebarContent from './ChannelLeftSidebarContent'
import ChannelAppHeader from './ChannelAppHeader';
import ChannelRoleDialog from 'app/shared-components/channel/ChannelRoleDialog';
import { setRootFolder, setCurrentFolder, getFolder } from 'app/store/fileItemsSlice';
import { selectChannel } from 'app/store/channelsSlice';
import reducer from './store';
import useLocationStatus from './useLocationStatus';
import LoadingBackdrop from 'app/shared-components/layout/LoadingBackdrop';

const Root = styled(FusePageSimple)(({ theme }) => ({
  '& .FusePageSimple-sidebar': {},
  '& .FusePageSimple-leftSidebar': {},
  '& .FusePageSimple-header': {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const ChannelAppContext = createContext({});

function ChannelApp({type, menuItems, returnPath, openRightSidebar, headerButton, headerBreadcrumb,
                      sidebarElement, sidebarElementFullHeight, onSidebarClose, customLeftSidebar}) {
  const dispatch = useDispatch();
  const pageLayout = useRef(null);
  const routeParams = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {isChannel, isClient, isHome, isFile, isTopic, isMember, isAdmin, isResult, isVideoCall, isSearchResults} = useLocationStatus();
  const groupId= routeParams.groupId;
  const group= useSelector(selectChannel(groupId));
  const rootFolderId= group?.entity?.folderId;
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(!isMobile);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const isRightSidebarOpen= openRightSidebar ? openRightSidebar : (isTopic || isMember || isResult || isFile);
  const appBaseUrl= "/apps/" + type + "/" + groupId;
  const useReturnPath= !isRightSidebarOpen ?  undefined : returnPath ? returnPath : -1;
  let contentClasses= "flex flex-auto justify-center w-full mx-auto";
  if (!isAdmin) contentClasses= contentClasses + " h-full";
  if (!isChannel && !isHome && !isClient) contentClasses= contentClasses + " px-24";

  console.log("ChannelApp: " + groupId);
  console.log("isRightSidebarOpen: " + isRightSidebarOpen);
  console.log("rightSidebarOpen: " + rightSidebarOpen);

  useDeepCompareEffect(() => {
    if (rootFolderId){
	    dispatch(setRootFolder({id: rootFolderId, name: "Files"}));
    	dispatch(setCurrentFolder(rootFolderId));
    	dispatch(getFolder(rootFolderId)); //This will update the generic entry above when complete - only needed for storage values
	  }
  }, [dispatch, rootFolderId]);

  useEffect(() => {
    setRightSidebarOpen(isRightSidebarOpen);
  }, [isRightSidebarOpen]);
  
  useEffect(() => {
    setLeftSidebarOpen(!isMobile);
  }, [isMobile]);

  function onCloseRightSidebar(){
    if (onSidebarClose) onSidebarClose();
    else navigate(useReturnPath);
  }

  function closeLeftSidebar(){
	  if (isMobile) setLeftSidebarOpen(false);
  }
  
  if (!group) return null;
  
  return (
   <ChannelAppContext.Provider
      value={{ setRightSidebarOpen }}
   >
    <Root
      header={
	   <>
        <ChannelAppHeader onSetSidebarOpen={setLeftSidebarOpen} type={type} pageLayout={pageLayout} button={headerButton} breadcrumb={headerBreadcrumb}/>
       </>
      }
      content={
        <div className={contentClasses}>
		  <Outlet context={[leftSidebarOpen, rightSidebarOpen]}/>
		  <LoadingBackdrop/>
		  <ChannelRoleDialog/>
        </div>
      }
      ref={pageLayout}
      rightSidebarVariant="temporary"
      rightSidebarContent={ <ChannelRightSidebarContent type={type}
                                                        element={sidebarElement}
                                                        sidebarElementFullHeight={sidebarElementFullHeight}
                                                        /> }
      rightSidebarOpen={rightSidebarOpen}
      rightSidebarOnClose={ onCloseRightSidebar  }
      rightSidebarWidth={600}
      leftSidebarOpen={leftSidebarOpen}
      leftSidebarOnClose={() => {
        setLeftSidebarOpen(false);
      }}
      leftSidebarContent={
        customLeftSidebar ? 
          React.createElement(customLeftSidebar, {
            closeSidebar: closeLeftSidebar,
            orgSidebarContent: <ChannelLeftSidebarContent closeSidebar={closeLeftSidebar} type={type} items={menuItems}/>
          }) :
          <ChannelLeftSidebarContent closeSidebar={closeLeftSidebar} type={type} items={menuItems}/>
      }
      scroll={isChannel || isHome ? 'content' : 'page'}
    />
  </ChannelAppContext.Provider>
  );
}

export default withReducer('channelApp', reducer)(ChannelApp);

